module.exports = __webpack_public_path__ + "static/media/generic-popup-1.a8d4ee85.svg";